module.exports = require('./helpers/bundle-url').getBundleURL('72x2m') + "snowAnimationSwitchStyles.1d265b48.css";